// extracted by mini-css-extract-plugin
module.exports = {"container":"Buttons_container__2FXsP","header":"Buttons_header__5Q62l","description":"Buttons_description__3QXjn"};